import { render, staticRenderFns } from "./popup-pickup-info.vue?vue&type=template&id=b5a1720a&scoped=true&"
import script from "./popup-pickup-info.vue?vue&type=script&lang=js&"
export * from "./popup-pickup-info.vue?vue&type=script&lang=js&"
import style0 from "./popup-pickup-info.vue?vue&type=style&index=0&id=b5a1720a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b5a1720a",
  null
  
)

export default component.exports